import { Component, inject, OnInit } from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgcCookieConsentService, NgcStatusChangeEvent } from 'ngx-cookieconsent';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { tap } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { SessionService } from './auth/session.service';
import AppSettings from './common/app.settings';
import { BlockedUsersService } from './common/services/blocked-users.service';
import { ChatAccessControlService } from './components/chat/services/chat-access-control.service';
import { CountriesService } from './services/countries.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private authService = inject(AuthService);
  private sessionService = inject(SessionService);
  private countriesService = inject(CountriesService);
  private blockedUsersService = inject(BlockedUsersService);
  private chatAccessControlService = inject(ChatAccessControlService);
  private cookieConsentService = inject(NgcCookieConsentService);
  private googleAnalyticsService = inject(GoogleAnalyticsService);

  public constructor() {
    this.sessionService.sessionStartedInOtherTab
      .pipe(
        takeUntilDestroyed(),
        tap(() => {
          this.initUserInfo();
        }),
      )
      .subscribe();

    this.sessionService.secondAuthenticationLevelGained
      .pipe(
        takeUntilDestroyed(),
        tap(() => {
          this.authService.refetchUserDataAfter2FA();
        }),
      )
      .subscribe();

    this.cookieConsentService.statusChange$.pipe(takeUntilDestroyed()).subscribe((event: NgcStatusChangeEvent) => {
      if (event.status === 'deny') {
        this.googleAnalyticsService.gtag('consent', 'update', {
          ad_storage: 'denied',
          analytics_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
        });
      }
    });
  }

  public ngOnInit(): void {
    this.initUserInfo();
    this.outputAppVersion();

    this.countriesService.setupCountryInfo();
    this.blockedUsersService.subscribeToSession();
    this.chatAccessControlService.subscribeToSession();
  }

  private outputAppVersion(): void {
    window.console.info(
      `%c 1Life2Connect™ v${AppSettings.APP_VERSION} `,
      'background-color: rgb(105, 228, 187); font-size: 18px;',
    );
  }

  private initUserInfo(): void {
    if (this.sessionService.tryRecoveringSession()) {
      this.authService.recoverUserData(this.sessionService.userId);
    }
  }
}
